// Monkey-patch JavaScript context to contain all EcmaScript 5, 6 methods
// that can be faithfully emulated with a legacy JavaScript engine, e.g. IE
import ReactOnRails from 'react-on-rails';
import { WidgetXcomponent } from '../../../sdk/js/src/btaWidgetLoader/zoid';

import ActivityWidgetContainer from '../widgets/container/ActivityLoadable';
import AppointmentWidgetContainer from '../widgets/container/AppointmentLoadable';
import CalendarWidgetContainer from '../widgets/container/CalendarLoadable';
import ClassWidgetContainer from '../widgets/container/ClassLoadable';
import CourseWidgetContainer from '../widgets/container/CourseLoadable';
import EventsListWidgetContainer from '../widgets/container/EventsListLoadable';
import ReservationWidgetContainer from '../widgets/container/ReservationLoadable';
import RentalWidgetContainer from '../widgets/container/RentalLoadable';
import SearchWidgetContainer from '../widgets/container/SearchLoadable';
import UpcomingEventWidgetContainer from '../widgets/container/UpcomingEventLoadable';

__webpack_public_path__ = `${process.env.CLOUDFRONT_ENDPOINT || '//legros-parker-and-harris6290.bookthatapp.local:3002'}/packs/`;

// Styles
import '../stylesheets/widgets.scss';
import 'core-js/stable';

ReactOnRails.register({
  ActivityWidgetContainer,
  AppointmentWidgetContainer,
  UpcomingEventWidgetContainer,
  ReservationWidgetContainer,
  CourseWidgetContainer,
  RentalWidgetContainer,
  CalendarWidgetContainer,
  ClassWidgetContainer,
  EventsListWidgetContainer,
  SearchWidgetContainer
});
